import { normalizePath } from '~/utils/path'
import { computedWithControl } from '@vueuse/core'

export class FilingCodes {
  static async use() {
    const { getFilingCodeContent } = Cms.use()
    const { route } = AppRoute.use()
    const appStore = ApplicationStore.use()
    const session = SessionStore.use()
    const profile = ProfileStore.use()
    const { environment } = DevModeHelpers.use()

    const { content } = await getFilingCodeContent()

    const matchesAnyPath = (paths: any[]) =>
      paths.some((p: any) => {
        if (p === '/') {
          return route.path === '/'
        }
        return route.path.startsWith(normalizePath(p))
      })

    const tests = computed(() => ({
      paths(config: any) {
        return _isNil(config.paths) || matchesAnyPath(config.paths)
      },
      exceptPaths(config: any) {
        return _isNil(config.exceptPaths) || !matchesAnyPath(config.exceptPaths)
      },
      planYears(config: any) {
        return _isNil(config.planYears) || config.planYears.includes(session.planYear)
      },
      environments(config: any) {
        return _isNil(config.environments) || config.environments.includes(environment.value)
      }
    }))

    const filingCodes = computedWithControl(
      () => [route.path, session.planYear, appStore.currentApp?.medicareId, environment.value],
      () => {
        if (
          route.path.startsWith('/apply') &&
          profile.location.stateCode === 'MI' &&
          appStore.currentApp?.medicareId?.startsWith('H0963')
        ) {
          return ['2023-099', 'H0963_HPT2025-165_C']
        }

        return content.value
          .filter((code) => {
            if (Object.keys(code.config).length === 0) return true

            return Object.entries(tests.value).every(([_, test]) => {
              return test(code.config)
            })
          })
          .map((code) => code.filingCode)
      }
    )

    return {
      filingCodes
    }
  }
}
